import { useNavigate } from 'react-router-dom'

export const PRODUCT_FORM_URL =
  '/assembly/detail/:transferId/:docNum/products/form/:ean'

export const useGoToProductForm = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, ean: string, docNum: string) => {
      navigate(
        PRODUCT_FORM_URL.replace(':transferId', transferId)
          .replace(':docNum', docNum)
          .replace(':ean', ean)
      )
    }
  }
}
